import type { ReactNode } from 'react';

import type { ButtonOrLinkData } from '#/components/ButtonOrLink/ButtonOrLinkData';

import { StyledLayoutHeaderButton } from './LayoutHeaderButton.styled';

type Props = {
  children: ReactNode;
  variant:
    | 'grey'
    | 'blue'
    | 'secondary'
    | 'green'
    | 'white'
    | 'blueGreenAnimate';
  minWidth?: number;
  smallHorizontalPadding?: boolean;
  centerHorizontally?: boolean;
  qaId?: string;
  ariaLabel?: string;
  roundBottomWhenOpen?: boolean;
  data: ButtonOrLinkData;
  desktopData?: ButtonOrLinkData;
};

export function LayoutHeaderButton({
  children,
  variant,
  minWidth,
  smallHorizontalPadding,
  centerHorizontally,
  qaId,
  ariaLabel,
  roundBottomWhenOpen,
  data,
  desktopData,
}: Props) {
  const sharedProps = {
    'data-variant': variant,
    'data-small-horizontal-padding': smallHorizontalPadding || undefined,
    'data-round-bottom-when-open': roundBottomWhenOpen || undefined,
    'data-center-horizontally': centerHorizontally || undefined,
    style: { minWidth },
    qaId,
    'aria-label': ariaLabel,
  };

  return (
    <>
      <StyledLayoutHeaderButton
        // oxlint-disable-next-line react/jsx-props-no-spreading
        {...sharedProps}
        data-breakpoint={desktopData ? 'mobile' : undefined}
        data={data}
      >
        {children}
      </StyledLayoutHeaderButton>

      {desktopData && (
        <StyledLayoutHeaderButton
          // oxlint-disable-next-line react/jsx-props-no-spreading
          {...sharedProps}
          data-breakpoint="desktop"
          data={desktopData}
        >
          {children}
        </StyledLayoutHeaderButton>
      )}
    </>
  );
}
